import Agent, {
  type AgentInstances,
  type AgentParams,
  type AgentSuggestions,
} from './Agent';

// MetapromptAgent helps developers systematically improve AI agent instructions
// through reflection, editing, and testing cycles.
class MetapromptAgent extends Agent {
  static name = 'MetapromptAgent';

  static publicName = 'Metaprompt';

  static available(
    _agentParams: AgentParams,
    _agentInstances: AgentInstances
  ): boolean {
    // MetapromptAgent is only available in development, test, and staging environments
    const isAllowedEnvironment = ['development', 'test'].includes(
      window.railsEnv
    );
    const hasAiAccess = window.currentAccount?.hasGeneralAiAssistant || false;

    return isAllowedEnvironment && hasAiAccess;
  }

  getSuggestions(): AgentSuggestions {
    return [];
  }
}

Agent.register(MetapromptAgent);

export default MetapromptAgent;
